import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

type QueryValue = string | string[]

type CompatRouter = {
  isReady: boolean
  pathname: string
  asPath: string
  query: Record<string, QueryValue>
  push: (to: string) => Promise<void>
  replace: (to: string) => Promise<void>
}

export function useCompatRouter(): CompatRouter {
  const navigate = useNavigate()
  const location = useLocation()

  const query = useMemo<Record<string, QueryValue>>(() => {
    const params = new URLSearchParams(location.search)
    const out: Record<string, QueryValue> = {}

    for (const [key, value] of params.entries()) {
      const existing = out[key]
      if (typeof existing === 'undefined') {
        out[key] = value
      } else if (Array.isArray(existing)) {
        existing.push(value)
      } else {
        out[key] = [existing, value]
      }
    }

    return out
  }, [location.search])

  return {
    isReady: true,
    pathname: location.pathname,
    asPath: `${location.pathname}${location.search}`,
    query,
    push: async (to: string) => {
      navigate(to)
    },
    replace: async (to: string) => {
      navigate(to, { replace: true })
    }
  }
}
